import React, { ComponentProps, PropsWithChildren, ReactNode, useCallback } from "react";
import { Modal } from "../../modal";
import { DialogButton } from "..";
import { SimpleDialog } from "../simple-dialog";

export const ConfirmDialog = ({
	children,
	title,
	messageHtml,
	isOkDisabled = false,
	autoFocusOk = true,
	ok,
	cancel,
	onOk,
	onCancel,
	...modalProps
}: PropsWithChildren<{
	title?: ReactNode;
	messageHtml?: string;
	isOkDisabled?: boolean;
	autoFocusOk?: boolean;
	ok: ReactNode;
	cancel: ReactNode;
	onOk: () => void;
	onCancel: () => void;
}> &
	ComponentProps<typeof Modal>) => {
	const handleOnOkClick = useCallback(() => {
		onOk();
	}, [onOk]);

	const handleOnCancelClick = useCallback(() => {
		onCancel();
	}, [onCancel]);

	const Footer = () => (
		<>
			<DialogButton
				// eslint-disable-next-line jsx-a11y/no-autofocus
				autoFocus={autoFocusOk}
				type="button"
				disabled={isOkDisabled}
				onClick={handleOnOkClick}
			>
				{ok}
			</DialogButton>
			<DialogButton type="button" onClick={handleOnCancelClick}>
				{cancel}
			</DialogButton>
		</>
	);

	return (
		<SimpleDialog
			className="confirm-dialog"
			title={title}
			footer={<Footer />}
			contentHtml={messageHtml}
			onScrimClick={onCancel}
			{...modalProps}
		>
			{children}
		</SimpleDialog>
	);
};
ConfirmDialog.displayName = "ConfirmDialog";
